import { ErrorJson } from '../../shared/type/error_json';

export class ApiError extends Error {
  constructor(message: string, public status = 500) {
    super(message);
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, ApiError);
    }
  }

  static is<T extends ApiError>(this: new (...args: any[]) => T, e: unknown): e is T {
    return e instanceof this;
  }
}

class BadRequestError extends ApiError {
  constructor(public json: ErrorJson) {
    super(json.title, 400);

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, BadRequestError);
    }
  }
}

class ForbiddenError extends ApiError {
  constructor(public json: ErrorJson) {
    super(json.title, 403);

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, ForbiddenError);
    }
  }
}

class InternalServerError extends ApiError {
  constructor(public json: ErrorJson) {
    super(json.title, 500);

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, InternalServerError);
    }
  }
}

class NotFoundError extends ApiError {
  constructor(public json: ErrorJson) {
    super(json.title, 404);

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, NotFoundError);
    }
  }
}

class TooManyRequestError extends ApiError {
  constructor(public json: ErrorJson) {
    super(json.title, 429);

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, TooManyRequestError);
    }
  }
}

class UnauthorizedError extends ApiError {
  constructor(public json: ErrorJson) {
    super(json.title, 401);

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, UnauthorizedError);
    }
  }
}

export const ApiErrors = {
  BadRequestError,
  ForbiddenError,
  InternalServerError,
  NotFoundError,
  TooManyRequestError,
  UnauthorizedError,
};
